export default __webpack_public_path__ + "static/media/signup06tour-slide3.f9b03d62.jpg";